<template>
  <q-input
    :model-value="modelValue"
    outlined
    :label="label"
    :type="revealed ? 'text' : 'password'"
    :autocomplete="autocomplete"
    :name="name"
    :rules="rules"
    :disable="disable"
    :aria-describedby="describedby || undefined"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #prepend><q-icon name="lock" aria-hidden="true" /></template>
    <template #append>
      <q-btn
        flat
        round
        dense
        :icon="revealed ? 'visibility_off' : 'visibility'"
        :aria-label="revealed ? 'Скрыть пароль' : 'Показать пароль'"
        :aria-pressed="revealed ? 'true' : 'false'"
        :disable="disable"
        class="password-input__toggle"
        data-testid="password-visibility-toggle"
        @click="revealed = !revealed"
      />
    </template>
  </q-input>
</template>

<script>
export default {
  name: 'PasswordInput',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: 'Пароль' },
    autocomplete: { type: String, default: 'current-password' },
    name: { type: String, default: 'password' },
    rules: { type: Array, default: () => [] },
    disable: { type: Boolean, default: false },
    describedby: { type: String, default: '' }
  },
  data() {
    return { revealed: false }
  }
}
</script>

<style scoped>
.password-input__toggle { min-width: var(--sid-touch-target); min-height: var(--sid-touch-target); }
</style>
